import { Group } from '@/components/_common';
import formatterPrice from '@/utils/number/formatterPrice';
import { Popover } from 'antd';
import { FaInfoCircle } from 'react-icons/fa';
import './style.less';
import formatterPercent from '@/utils/number/formatterPercent';

interface Props {
  percent?: number;
  value?: number;
  total?: number;
}

export default function DiscountInfo({
  percent = 0,
  value = 0,
  total = 0,
}: Props) {
  if (!percent && !value) return null;

  const original = total + value;

  return (
    <Group className="discount">
      <span className="text">
        {formatterPercent(percent)} (-{formatterPrice(value)})
      </span>

      <Popover
        trigger="hover"
        placement="bottomRight"
        title="Desconto aplicado"
        content={
          <div className="popover">
            <Group gap={5}>
              <span>Valor original:</span>
              <strong>{formatterPrice(original)}</strong>
            </Group>

            <Group gap={5}>
              <span>Desconto ({formatterPercent(percent)}):</span>

              <strong>-{formatterPrice(value)}</strong>
            </Group>

            <Group gap={5}>
              <span>Total final: </span>
              <strong>{formatterPrice(total)}</strong>
            </Group>
          </div>
        }
      >
        <FaInfoCircle className="icon" />
      </Popover>
    </Group>
  );
}
